/**
 * Custom Spin Component
 * Extends Ant Design Spin with custom styling
 */

import { Spin as AntSpin, SpinProps } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import './CustomSpin.scss';

export interface CustomSpinProps extends SpinProps {
  /** Spin variant */
  variant?: 'default' | 'fullscreen' | 'inline';
}

/**
 * CustomSpin Component
 */
export const CustomSpin: React.FC<CustomSpinProps> = ({
  variant = 'default',
  className,
  indicator,
  ...rest
}) => {
  const spinClasses = classNames('custom-spin', `custom-spin--${variant}`, className);

  const defaultIndicator = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  return <AntSpin {...rest} indicator={indicator || defaultIndicator} className={spinClasses} />;
};

export default CustomSpin;

